import React from 'react'
import {
  Box,
  Button,
  IconButton,
} from 'components'
import {
  DialogTitle,
  DialogTitleProps,
} from 'components/Dialog'
import { useViewport } from 'hooks'
import { ArrowBack, Close } from 'icons'

export type FiltersDialogHeaderProps = DialogTitleProps & { onClose: () => void }
export const FiltersDialogHeader: React.FC<FiltersDialogHeaderProps> = ({ children, ...props }) => {
  const { isMedium } = useViewport()

  return <DialogTitle {...props as DialogTitleProps} sx={[
    (theme) => ({
      [theme.breakpoints.up('md')]: {
        borderBottomWidth: '1px',
        borderBottomStyle: 'solid',
        borderBottomColor: theme.palette.divider,
      },
    }),
    ...(Array.isArray(props.sx) ? props.sx : [props.sx])
  ]}>
    <Box display="flex" alignItems="center" justifyContent="space-between" gap={2}>
      { !isMedium && <Box>
        <Button
          aria-label="close"
          onClick={props.onClose}
          variant="text"
        >
          <ArrowBack />
        </Button>
      </Box> }

      <Box flexGrow={1}>
        { children }
      </Box>

      { isMedium && <Box ml="auto">
        <IconButton
          aria-label="close"
          onClick={props.onClose}
          sx={{ mr: -1 }}
        >
          <Close />
        </IconButton>
      </Box> }
    </Box>
  </DialogTitle>
}

export default FiltersDialogHeader
